// extracted by mini-css-extract-plugin
export default {"errorMessage":"MessageContainer_errorMessage__s81IL"};